module.exports = __webpack_public_path__ + "img/Subtract.4174fc51.png";